/* eslint-disable max-len */

export const baseAppRoutes = {
  Accreditation: '/accreditation',
  DataQuality: '/data-quality',
  MSIS_ID: '/msisidquery',
  LEASchoolInput: '/input/district-school-info',
  OTSSInput: '/input/mde-otss',
  StudentInput: '/input/student',
  StudentOwnership: '/student-owner',
  Reports: '/report',
  Files: '/file',
  User: '/user',
  Upload: '/upload',
  BoardMembersInput: '/input/district-school-info',
  Announcements: '/announcements',
};
/* istanbul ignore next */

export const appRoutePaths = {
  Dashboard: '/',
  Login: '/login',
  NewUser: '/welcome',
  GetToken: '/get-token',
  Logout: '/logout',
  ShowToken: '/show-token',
  Feedback: '/feedback',
  HelpCenter: '/help-center',
  SubmissionStatus: `${baseAppRoutes.Files}`,
  DataQualityDashboard: `${baseAppRoutes.DataQuality}`,
  Accreditation: `${baseAppRoutes.Accreditation}`,
  AccreditationEdits: (category = ':category') =>
    `${baseAppRoutes.Accreditation}/${category}`,
  Announcements: `${baseAppRoutes.Announcements}`,
  BoardMembersList: `${baseAppRoutes.BoardMembersInput}/board-members`,
  BoardMembersInput: (id = ':id') =>
    `${baseAppRoutes.BoardMembersInput}/board-members/${id}`,
  DyslexiaScreenerList: (schoolYear = ':schoolYear') =>
    `${baseAppRoutes.LEASchoolInput}/dyslexia-screener/${schoolYear}`,
  DyslexiaScreenerInput: (
    dyslexiaScreenerId = ':dyslexiaScreenerId',
    schoolYear = ':schoolYear'
  ) =>
    `${baseAppRoutes.LEASchoolInput}/dyslexia-screener/${dyslexiaScreenerId}/${schoolYear}`,
  DataQualityCategory: (category = ':category') =>
    `${baseAppRoutes.DataQuality}/${category}`,
  DataQualityDetail: (category = ':category', errorLevel = ':errorLevel') =>
    `${baseAppRoutes.DataQuality}/${category}/${errorLevel}`,
  FileUpload: `${baseAppRoutes.Upload}/file`,
  FileDetail: (fileId = ':fileId') => `${baseAppRoutes.Files}/${fileId}`,
  MSISRequest: `${baseAppRoutes.MSIS_ID}`,
  MSISRequestNew: `${baseAppRoutes.MSIS_ID}/new`,
  MSISRequestDetail: (requestId = ':requestId') =>
    `${baseAppRoutes.MSIS_ID}/${requestId}`,
  StudentOwnership: `${baseAppRoutes.StudentOwnership}`,
  StudentOwnershipDetail: (ownerConflictId = ':ownerConflictId') =>
    `${baseAppRoutes.StudentOwnership}/${ownerConflictId}`,
  ReportDashboard: `${baseAppRoutes.Reports}`,
  ReportDisplay: (reportId = ':reportId') =>
    `${baseAppRoutes.Reports}/${reportId}`,
  CharterSchoolAuthorizingOrganizationList: `${baseAppRoutes.LEASchoolInput}/charter-school/authorizing-organization`,
  LEAManagementList: `${baseAppRoutes.LEASchoolInput}/lea-management`,
  LEAManagementInput: (leaId = ':leaId') =>
    `${baseAppRoutes.LEASchoolInput}/lea-management/${leaId}`,
  NewCharterSchoolAuthorizingOrganization: `${baseAppRoutes.LEASchoolInput}/charter-school/authorizing-organization/new`,
  NewCharterSchoolManagementOrganization: `${baseAppRoutes.LEASchoolInput}/charter-school/management-organization/new`,
  NewCharterSchoolAssignment: `${baseAppRoutes.LEASchoolInput}/charter-school/assignment/new`,
  SchoolManagementList: `${baseAppRoutes.LEASchoolInput}/school-management`,
  SchoolManagementInput: (schoolIdentifier = ':schoolIdentifier') =>
    `${baseAppRoutes.LEASchoolInput}/school-management/${schoolIdentifier}`,
  LEASharingList: `${baseAppRoutes.LEASchoolInput}/lea-sharing`,
  LEASharingInput: (leaId = ':leaId') =>
    `${baseAppRoutes.LEASchoolInput}/lea-sharing/${leaId}`,
  SalaryScaleList: `${baseAppRoutes.LEASchoolInput}/salary-scale`,
  SeaOrganizationList: `${baseAppRoutes.OTSSInput}/sea-organization`,
  SeaOrganizationInput: (seaOrganizationId = ':seaOrganizationId') =>
    `${baseAppRoutes.OTSSInput}/sea-organization/${seaOrganizationId}`,
  CourseCodeList: `${baseAppRoutes.OTSSInput}/course-code`,
  CourseCodeInput: (courseCodeId = ':courseCodeId') =>
    `${baseAppRoutes.OTSSInput}/course-code/${courseCodeId}`,
  NonPublicStudentEntryList: `${baseAppRoutes.StudentInput}/non-public-student-entry`,
  NonPublicStudentEntryInput: (
    nonPublicStudentId = ':nonPublicStudentId',
    schoolYear = ':schoolYear'
  ) =>
    `${baseAppRoutes.StudentInput}/non-public-student-entry/${nonPublicStudentId}/${schoolYear}`,
  NonPublicStudentEntryScheduleInput: (
    nonPublicStudentId = ':nonPublicStudentId',
    scheduleId = ':scheduleId'
  ) =>
    `${baseAppRoutes.StudentInput}/non-public-student-entry/${nonPublicStudentId}/schedule/${scheduleId}`,
  SummerActivityList: `${baseAppRoutes.StudentInput}/summer-activity`,
  SummerActivityInput: (summerActivityId = ':summerActivityId') =>
    `${baseAppRoutes.StudentInput}/summer-activity/${summerActivityId}`,
  StudentInterventionList: `${baseAppRoutes.StudentInput}/student-intervention`,
  StudentInterventionInput: (
    studentInterventionId = ':studentInterventionId',
    schoolYear = ':schoolYear'
  ) =>
    `${baseAppRoutes.StudentInput}/student-intervention/${studentInterventionId}/${schoolYear}`,
  SeniorSnapshotList: `${baseAppRoutes.StudentInput}/senior-snapshot`,
  SeniorSnapshotInput: (seniorSnapshotId = ':seniorSnapshotId') =>
    `${baseAppRoutes.StudentInput}/senior-snapshot/${seniorSnapshotId}`,
  ExitAdjustmentList: `${baseAppRoutes.StudentInput}/exit-adjustment`,
  ExitAdjustmentInput: (exitAdjustmentId = ':exitAdjustmentId') =>
    `${baseAppRoutes.StudentInput}/exit-adjustment/${exitAdjustmentId}`,
  SealOfBiliteracyList: (schoolYear = ':schoolYear') =>
    `${baseAppRoutes.StudentInput}/seal-of-biliteracy/${schoolYear}`,
  SealOfBiliteracyInput: (
    sealOfBiliteracyId = ':sealOfBiliteracyId',
    schoolYear = ':schoolYear'
  ) =>
    `${baseAppRoutes.StudentInput}/seal-of-biliteracy/${sealOfBiliteracyId}/${schoolYear}`,
  GradesAndPromotionsList: `${baseAppRoutes.StudentInput}/grades-and-promotions`,
  GradesAndPromotionsInput: (schoolYear = ':schoolYear') =>
    `${baseAppRoutes.StudentInput}/grades-and-promotions/${schoolYear}`,
  UserList: `${baseAppRoutes.User}`,
  UserDetail: (userId = ':userId') => `${baseAppRoutes.User}/${userId}`,
  UserEdit: (userId = ':userId') => `${baseAppRoutes.User}/edit/${userId}`,
  LiteracyScreeningList: `${baseAppRoutes.LEASchoolInput}/literacy-screening`,
  LiteracyScreeningInput: (schoolYear = ':schoolYear') =>
    `${baseAppRoutes.LEASchoolInput}/literacy-screening/${schoolYear}`,
  LiteracyScreeningSchoolInput: (
    leaIdentifier = ':leaIdentifier',
    schoolIdentifier = ':schoolIdentifier',
    schoolYear = ':schoolYear',
    id = ':id'
  ) =>
    `${baseAppRoutes.LEASchoolInput
    }/literacy-screening/${leaIdentifier}/${schoolIdentifier}/${schoolYear}/${id || 'new'
    }`,
  NeglectedOrDelinquentList: `${baseAppRoutes.LEASchoolInput}/neglected-or-delinquent`,
  NeglectedOrDelinquentInput: (schoolYear = ':schoolYear') =>
    `${baseAppRoutes.LEASchoolInput}/neglected-or-delinquent/${schoolYear}`,
};
